// Bridge that lets a legacy v1 page (the class form) open the v2 SBG
// topics-set builder dialog. v1 cannot import v2 modules, so the seam is a
// window global and only plain data + callbacks cross it - the same isolation
// openComposeDrawer uses.
//
// This module stays dependency-free on purpose: it is imported eagerly by the
// chrome entrypoint, and pulling the dialog in here would put it into the
// chunk every legacy page loads. The real implementation is fetched on first
// open and cached for later opens.
let appModule = null;

const loadApp = () => {
  appModule ||= import("./sbgTopicsSet/sbgTopicsSetChromeApp");
  return appModule;
};

// opts: { subjectId, subjectName?, grades?, onSaved?(set), onClose? }
// onSaved receives the created set ({ id, name, topic_ids }) so the caller can
// select it without refetching.
function openSbgTopicsSetDialog(opts) {
  loadApp().then((mod) => mod.open(opts));
}

// Namespaced merge so each chrome surface can attach its own helpers.
window.AeChrome = {
  ...(window.AeChrome || {}),
  openSbgTopicsSetDialog,
};

// Same readiness signal the other chrome bridges use: the chrome bundle can
// evaluate after a v1 page has already mounted. More than one surface
// dispatches this, so listeners check for the specific function they need.
window.dispatchEvent(new Event("aechrome:ready"));
